export default {
  bind(el) {
    el.style.position = "absolute";
    el.style.cursor = "grab";

    const dragData = {
      isDragging: false,
      offsetX: 0,
      offsetY: 0,
    };

    const isResizingArea = (event) => {
      // 检测是否点击右下角 10px 区域
      const rect = el.getBoundingClientRect();
      const resizeThreshold = 10; // 调整大小区域的阈值
      return (
        event.clientX > rect.right - resizeThreshold &&
        event.clientY > rect.bottom - resizeThreshold
      );
    };

    const onMouseDown = (event) => {
      if (event.button !== 0) return;

      // 如果是在调整大小区域，跳过拖拽逻辑
      if (isResizingArea(event)) {
        return;
      }

      event.preventDefault();
      dragData.isDragging = true;
      dragData.offsetX = event.clientX - el.offsetLeft;
      dragData.offsetY = event.clientY - el.offsetTop;
      el.style.cursor = "grabbing";
    };

    const onMouseMove = (event) => {
      if (dragData.isDragging) {
        event.preventDefault();
        el.style.left = `${event.clientX - dragData.offsetX}px`;
        el.style.top = `${event.clientY - dragData.offsetY}px`;
      }
    };

    const onMouseUp = () => {
      dragData.isDragging = false;
      el.style.cursor = "grab";
    };

    // 添加事件监听
    el.__dragHandlers__ = { onMouseDown, onMouseMove, onMouseUp };
    el.addEventListener("mousedown", onMouseDown);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  },
  unbind(el) {
    const { onMouseDown, onMouseMove, onMouseUp } = el.__dragHandlers__;
    el.removeEventListener("mousedown", onMouseDown);
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", onMouseUp);
    delete el.__dragHandlers__;
  },
};



// WEBPACK FOOTER //
// ./src/directive/drag.js